//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.2.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ISynonymsRulesClient {
    /**
     * Obtener reglas de sinónimos
     * @param page (optional) Índice de página (inicia en 0)
     * @param size (optional) Cantidad de elementos por página
     * @param status (optional) Filtra por estado (ACTIVE / INACTIVE)
     * @param q (optional) Término de búsqueda por nombre de regla
     */
    list(page?: number | undefined, size?: number | undefined, status?: Status | undefined, q?: string | undefined): Observable<SynonymsPageDto>;
    /**
     * Crear regla de sinónimo
     */
    create(body: CreateSynonymsDto): Observable<CreateSynonymsResponseDto>;
    /**
     * Obtener detalle de regla de sinónimo
     */
    getById(synonymId: string): Observable<GetSynonymsByIdResponseDto>;
    /**
     * Actualizar regla de sinónimo
     */
    update(synonymId: string, body: UpdateSynonymsDto): Observable<UpdateSynonymsResponseDto>;
    /**
     * Eliminar regla de sinónimo
     */
    delete(synonymId: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class SynonymsRulesClient implements ISynonymsRulesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Obtener reglas de sinónimos
     * @param page (optional) Índice de página (inicia en 0)
     * @param size (optional) Cantidad de elementos por página
     * @param status (optional) Filtra por estado (ACTIVE / INACTIVE)
     * @param q (optional) Término de búsqueda por nombre de regla
     */
    list(page?: number | undefined, size?: number | undefined, status?: Status | undefined, q?: string | undefined): Observable<SynonymsPageDto> {
        let url_ = this.baseUrl + "/hub/search/synonyms?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SynonymsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SynonymsPageDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<SynonymsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SynonymsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Crear regla de sinónimo
     */
    create(body: CreateSynonymsDto): Observable<CreateSynonymsResponseDto> {
        let url_ = this.baseUrl + "/hub/search/synonyms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSynonymsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSynonymsResponseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateSynonymsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateSynonymsResponseDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Obtener detalle de regla de sinónimo
     */
    getById(synonymId: string): Observable<GetSynonymsByIdResponseDto> {
        let url_ = this.baseUrl + "/hub/search/synonyms/{synonymId}";
        if (synonymId === undefined || synonymId === null)
            throw new globalThis.Error("The parameter 'synonymId' must be defined.");
        url_ = url_.replace("{synonymId}", encodeURIComponent("" + synonymId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSynonymsByIdResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSynonymsByIdResponseDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetSynonymsByIdResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSynonymsByIdResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Regla no encontrada", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Actualizar regla de sinónimo
     */
    update(synonymId: string, body: UpdateSynonymsDto): Observable<UpdateSynonymsResponseDto> {
        let url_ = this.baseUrl + "/hub/search/synonyms/{synonymId}";
        if (synonymId === undefined || synonymId === null)
            throw new globalThis.Error("The parameter 'synonymId' must be defined.");
        url_ = url_.replace("{synonymId}", encodeURIComponent("" + synonymId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSynonymsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSynonymsResponseDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateSynonymsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSynonymsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Eliminar regla de sinónimo
     */
    delete(synonymId: string): Observable<void> {
        let url_ = this.baseUrl + "/hub/search/synonyms/{synonymId}";
        if (synonymId === undefined || synonymId === null)
            throw new globalThis.Error("The parameter 'synonymId' must be defined.");
        url_ = url_.replace("{synonymId}", encodeURIComponent("" + synonymId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class SynonymsPageDto implements ISynonymsPageDto {
    /** Metadatos de paginación */
    page!: PageDto;
    /** Lista de reglas de sinonimos */
    items!: SynonymRuleDto[];

    [key: string]: any;

    constructor(data?: ISynonymsPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.page = new PageDto();
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"] ? PageDto.fromJS(_data["page"]) : new PageDto();
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SynonymRuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SynonymsPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynonymsPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page ? this.page.toJSON() : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISynonymsPageDto {
    /** Metadatos de paginación */
    page: PageDto;
    /** Lista de reglas de sinonimos */
    items: SynonymRuleDto[];

    [key: string]: any;
}

export class CreateSynonymsDto implements ICreateSynonymsDto {
    /** Tipo de sinónimo */
    type!: CreateSynonymsDtoType;
    /** Estado de la regla */
    status!: CreateSynonymsDtoStatus;
    /** Términos de entrada o grupo de sinónimos */
    inputTerms!: string[];
    /** Términos destino (solo para UNIDIRECTIONAL, vacío para BIDIRECTIONAL) */
    targetTerms!: string[];

    [key: string]: any;

    constructor(data?: ICreateSynonymsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.inputTerms = [];
            this.targetTerms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.status = _data["status"];
            if (Array.isArray(_data["inputTerms"])) {
                this.inputTerms = [] as any;
                for (let item of _data["inputTerms"])
                    this.inputTerms!.push(item);
            }
            if (Array.isArray(_data["targetTerms"])) {
                this.targetTerms = [] as any;
                for (let item of _data["targetTerms"])
                    this.targetTerms!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSynonymsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSynonymsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["status"] = this.status;
        if (Array.isArray(this.inputTerms)) {
            data["inputTerms"] = [];
            for (let item of this.inputTerms)
                data["inputTerms"].push(item);
        }
        if (Array.isArray(this.targetTerms)) {
            data["targetTerms"] = [];
            for (let item of this.targetTerms)
                data["targetTerms"].push(item);
        }
        return data;
    }
}

export interface ICreateSynonymsDto {
    /** Tipo de sinónimo */
    type: CreateSynonymsDtoType;
    /** Estado de la regla */
    status: CreateSynonymsDtoStatus;
    /** Términos de entrada o grupo de sinónimos */
    inputTerms: string[];
    /** Términos destino (solo para UNIDIRECTIONAL, vacío para BIDIRECTIONAL) */
    targetTerms: string[];

    [key: string]: any;
}

export class CreateSynonymsResponseDto implements ICreateSynonymsResponseDto {
    /** Identificador único de la regla de sinónimo creada */
    id!: string;

    [key: string]: any;

    constructor(data?: ICreateSynonymsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateSynonymsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSynonymsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateSynonymsResponseDto {
    /** Identificador único de la regla de sinónimo creada */
    id: string;

    [key: string]: any;
}

export class GetSynonymsByIdResponseDto implements IGetSynonymsByIdResponseDto {
    /** Identificador único de la regla de sinónimo */
    id!: string;
    /** Tipo de sinónimo */
    type!: GetSynonymsByIdResponseDtoType;
    /** Estado de la regla de sinónimo */
    status!: GetSynonymsByIdResponseDtoStatus;
    /** Términos de entrada o grupo de sinónimos. En BIDIRECTIONAL todos son equivalentes. */
    inputTerms!: string[];
    /** Términos destino. Solo aplica para UNIDIRECTIONAL. Vacío para BIDIRECTIONAL. */
    targetTerms!: string[];

    [key: string]: any;

    constructor(data?: IGetSynonymsByIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.inputTerms = [];
            this.targetTerms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"];
            this.status = _data["status"];
            if (Array.isArray(_data["inputTerms"])) {
                this.inputTerms = [] as any;
                for (let item of _data["inputTerms"])
                    this.inputTerms!.push(item);
            }
            if (Array.isArray(_data["targetTerms"])) {
                this.targetTerms = [] as any;
                for (let item of _data["targetTerms"])
                    this.targetTerms!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSynonymsByIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSynonymsByIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type;
        data["status"] = this.status;
        if (Array.isArray(this.inputTerms)) {
            data["inputTerms"] = [];
            for (let item of this.inputTerms)
                data["inputTerms"].push(item);
        }
        if (Array.isArray(this.targetTerms)) {
            data["targetTerms"] = [];
            for (let item of this.targetTerms)
                data["targetTerms"].push(item);
        }
        return data;
    }
}

export interface IGetSynonymsByIdResponseDto {
    /** Identificador único de la regla de sinónimo */
    id: string;
    /** Tipo de sinónimo */
    type: GetSynonymsByIdResponseDtoType;
    /** Estado de la regla de sinónimo */
    status: GetSynonymsByIdResponseDtoStatus;
    /** Términos de entrada o grupo de sinónimos. En BIDIRECTIONAL todos son equivalentes. */
    inputTerms: string[];
    /** Términos destino. Solo aplica para UNIDIRECTIONAL. Vacío para BIDIRECTIONAL. */
    targetTerms: string[];

    [key: string]: any;
}

export class UpdateSynonymsDto implements IUpdateSynonymsDto {
    /** Tipo de sinónimo */
    type!: UpdateSynonymsDtoType;
    /** Estado de la regla */
    status!: UpdateSynonymsDtoStatus;
    /** Términos de entrada o grupo de sinónimos */
    inputTerms!: string[];
    /** Términos destino (solo para UNIDIRECTIONAL, vacío para BIDIRECTIONAL) */
    targetTerms!: string[];

    [key: string]: any;

    constructor(data?: IUpdateSynonymsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.inputTerms = [];
            this.targetTerms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.status = _data["status"];
            if (Array.isArray(_data["inputTerms"])) {
                this.inputTerms = [] as any;
                for (let item of _data["inputTerms"])
                    this.inputTerms!.push(item);
            }
            if (Array.isArray(_data["targetTerms"])) {
                this.targetTerms = [] as any;
                for (let item of _data["targetTerms"])
                    this.targetTerms!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSynonymsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSynonymsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["status"] = this.status;
        if (Array.isArray(this.inputTerms)) {
            data["inputTerms"] = [];
            for (let item of this.inputTerms)
                data["inputTerms"].push(item);
        }
        if (Array.isArray(this.targetTerms)) {
            data["targetTerms"] = [];
            for (let item of this.targetTerms)
                data["targetTerms"].push(item);
        }
        return data;
    }
}

export interface IUpdateSynonymsDto {
    /** Tipo de sinónimo */
    type: UpdateSynonymsDtoType;
    /** Estado de la regla */
    status: UpdateSynonymsDtoStatus;
    /** Términos de entrada o grupo de sinónimos */
    inputTerms: string[];
    /** Términos destino (solo para UNIDIRECTIONAL, vacío para BIDIRECTIONAL) */
    targetTerms: string[];

    [key: string]: any;
}

export class UpdateSynonymsResponseDto implements IUpdateSynonymsResponseDto {
    /** Identificador único de la regla de sinónimo */
    id!: string;
    /** Tipo de sinónimo */
    type!: UpdateSynonymsResponseDtoType;
    /** Estado de la regla */
    status!: UpdateSynonymsResponseDtoStatus;
    /** Términos de entrada */
    inputTerms!: string[];
    /** Términos destino (vacío para BIDIRECTIONAL) */
    targetTerms!: string[];

    [key: string]: any;

    constructor(data?: IUpdateSynonymsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.inputTerms = [];
            this.targetTerms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"];
            this.status = _data["status"];
            if (Array.isArray(_data["inputTerms"])) {
                this.inputTerms = [] as any;
                for (let item of _data["inputTerms"])
                    this.inputTerms!.push(item);
            }
            if (Array.isArray(_data["targetTerms"])) {
                this.targetTerms = [] as any;
                for (let item of _data["targetTerms"])
                    this.targetTerms!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSynonymsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSynonymsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type;
        data["status"] = this.status;
        if (Array.isArray(this.inputTerms)) {
            data["inputTerms"] = [];
            for (let item of this.inputTerms)
                data["inputTerms"].push(item);
        }
        if (Array.isArray(this.targetTerms)) {
            data["targetTerms"] = [];
            for (let item of this.targetTerms)
                data["targetTerms"].push(item);
        }
        return data;
    }
}

export interface IUpdateSynonymsResponseDto {
    /** Identificador único de la regla de sinónimo */
    id: string;
    /** Tipo de sinónimo */
    type: UpdateSynonymsResponseDtoType;
    /** Estado de la regla */
    status: UpdateSynonymsResponseDtoStatus;
    /** Términos de entrada */
    inputTerms: string[];
    /** Términos destino (vacío para BIDIRECTIONAL) */
    targetTerms: string[];

    [key: string]: any;
}

export class PageDto implements IPageDto {
    /** Número de página */
    number!: number;
    /** Tamaño de página */
    size!: number;
    /** Total de elementos encontrados */
    totalElements!: number;
    /** Total de páginas segun size y totalElements */
    totalPages!: number;
    /** Búsqueda vacía */
    empty!: boolean;

    [key: string]: any;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            this.size = _data["size"];
            this.totalElements = _data["totalElements"];
            this.totalPages = _data["totalPages"];
            this.empty = _data["empty"];
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        data["size"] = this.size;
        data["totalElements"] = this.totalElements;
        data["totalPages"] = this.totalPages;
        data["empty"] = this.empty;
        return data;
    }
}

export interface IPageDto {
    /** Número de página */
    number: number;
    /** Tamaño de página */
    size: number;
    /** Total de elementos encontrados */
    totalElements: number;
    /** Total de páginas segun size y totalElements */
    totalPages: number;
    /** Búsqueda vacía */
    empty: boolean;

    [key: string]: any;
}

export class SynonymRuleDto implements ISynonymRuleDto {
    /** Identificador único de la regla de sinónimo */
    id!: string;
    /** Tipo de sinónimo */
    type!: SynonymRuleDtoType;
    /** Estado de la regla de sinónimo */
    status!: SynonymRuleDtoStatus;
    /** Términos de entrada o grupo de sinónimos. En BIDIRECTIONAL todos son equivalentes. */
    inputTerms!: string[];
    /** Términos destino. Solo aplica para UNIDIRECTIONAL. Vacío para BIDIRECTIONAL. */
    targetTerms!: string[];

    [key: string]: any;

    constructor(data?: ISynonymRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.inputTerms = [];
            this.targetTerms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"];
            this.status = _data["status"];
            if (Array.isArray(_data["inputTerms"])) {
                this.inputTerms = [] as any;
                for (let item of _data["inputTerms"])
                    this.inputTerms!.push(item);
            }
            if (Array.isArray(_data["targetTerms"])) {
                this.targetTerms = [] as any;
                for (let item of _data["targetTerms"])
                    this.targetTerms!.push(item);
            }
        }
    }

    static fromJS(data: any): SynonymRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynonymRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type;
        data["status"] = this.status;
        if (Array.isArray(this.inputTerms)) {
            data["inputTerms"] = [];
            for (let item of this.inputTerms)
                data["inputTerms"].push(item);
        }
        if (Array.isArray(this.targetTerms)) {
            data["targetTerms"] = [];
            for (let item of this.targetTerms)
                data["targetTerms"].push(item);
        }
        return data;
    }
}

export interface ISynonymRuleDto {
    /** Identificador único de la regla de sinónimo */
    id: string;
    /** Tipo de sinónimo */
    type: SynonymRuleDtoType;
    /** Estado de la regla de sinónimo */
    status: SynonymRuleDtoStatus;
    /** Términos de entrada o grupo de sinónimos. En BIDIRECTIONAL todos son equivalentes. */
    inputTerms: string[];
    /** Términos destino. Solo aplica para UNIDIRECTIONAL. Vacío para BIDIRECTIONAL. */
    targetTerms: string[];

    [key: string]: any;
}

export enum Status {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum CreateSynonymsDtoType {
    BIDIRECTIONAL = "BIDIRECTIONAL",
    UNIDIRECTIONAL = "UNIDIRECTIONAL",
}

export enum CreateSynonymsDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum GetSynonymsByIdResponseDtoType {
    BIDIRECTIONAL = "BIDIRECTIONAL",
    UNIDIRECTIONAL = "UNIDIRECTIONAL",
}

export enum GetSynonymsByIdResponseDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum UpdateSynonymsDtoType {
    BIDIRECTIONAL = "BIDIRECTIONAL",
    UNIDIRECTIONAL = "UNIDIRECTIONAL",
}

export enum UpdateSynonymsDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum UpdateSynonymsResponseDtoType {
    BIDIRECTIONAL = "BIDIRECTIONAL",
    UNIDIRECTIONAL = "UNIDIRECTIONAL",
}

export enum UpdateSynonymsResponseDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum SynonymRuleDtoType {
    BIDIRECTIONAL = "BIDIRECTIONAL",
    UNIDIRECTIONAL = "UNIDIRECTIONAL",
}

export enum SynonymRuleDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}